// extracted by mini-css-extract-plugin
module.exports = {"List":"Shop_List__2CvLq","Item":"Shop_Item__3hiT5","Price":"Shop_Price__2E1eN","Poster":"Shop_Poster__2tHgf","Title":"Shop_Title__3Brmd","Description":"Shop_Description__6GUTS"};